import { defineAbility } from '@casl/ability'
import store from '@/store'
import { permissions } from '@/api/permissions/permissions'
import { adminRouteNames } from '@/router/pages/admin'
import { authRouteNames } from '@/router/pages/auth'
import { commonRouteNames } from '@/router/pages/common'
import { isDev, isProduction } from '@/config/urls'
import { devRouteNames } from '@/router/pages/dev'
import { profileRouteNames } from '@/router/pages/profile'
import { importRouteNames } from '@/router/pages/import'
import { journalsRouteNames } from '@/router/pages/journals'
import { requestsRouteNames } from '@/router/pages/requests'
import { managementRouteNames } from '@/router/pages/management'
import { publicationsRouteNames } from '@/router/pages/publications'
import { cttRouteNames } from '@/router/pages/ctt'

export class PermissionPageManager {
  public static _pages() {
    const rules: any = {}

    if (this.user('isAuthenticated')) {
      // Для авторизованных пользователей
      PermissionPageManager.addRule(authRouteNames.LogoutRoute, rules)
      PermissionPageManager.addRule(profileRouteNames.ProfileRoute, rules)
      PermissionPageManager.addRule(
        publicationsRouteNames.MyPublicationsRoute,
        rules
      )

      if (this.user('isCttMC') || this.user('isCttIPC')) {
        PermissionPageManager.addRule(cttRouteNames.RIDRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.InventionsRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.TechSolutionsRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.PhotosRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.NewsRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.ReferencesRoute, rules)
      }

      // Для администраторов
      if (this.user('isAdmin')) {
        PermissionPageManager.addRule(adminRouteNames.ServerLogsRoute, rules)
        PermissionPageManager.addRule(adminRouteNames.SessionsRoute, rules)
        PermissionPageManager.addRule(adminRouteNames.HistoryRoute, rules)
        PermissionPageManager.addRule(adminRouteNames.BuildInfoRoute, rules)
        PermissionPageManager.addRule(
          adminRouteNames.UserPermissionsRoute,
          rules
        )
        PermissionPageManager.addRule(adminRouteNames.SettingsRoute, rules)
        PermissionPageManager.addRule(devRouteNames.ServerAPIRoute, rules)
        PermissionPageManager.addRule(
          requestsRouteNames.NotificationsRequestsRoute,
          rules
        )
        PermissionPageManager.addRule(cttRouteNames.RIDRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.InventionsRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.TechSolutionsRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.PhotosRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.NewsRoute, rules)
        PermissionPageManager.addRule(cttRouteNames.ReferencesRoute, rules)
        PermissionPageManager.addRule(
          publicationsRouteNames.PublicationHistoryRoute,
          rules
        )
        PermissionPageManager.addRule(
          managementRouteNames.MergeUsersRoute,
          rules
        )
        PermissionPageManager.addRule(managementRouteNames.AuthorsRoute, rules)
        PermissionPageManager.addRule(
          journalsRouteNames.JournalsCheckRoute,
          rules
        )

        if (!this.user('isFakeAuth') && isProduction) {
          PermissionPageManager.addRule(devRouteNames.FakeAuthRoute, rules)
        }
      }
      if (this.user('isEditor')) {
        PermissionPageManager.addRule(profileRouteNames.MetabaseRoute, rules)
        PermissionPageManager.addRule(
          importRouteNames.ImportProcessRoute,
          rules
        )
        PermissionPageManager.addRule(
          requestsRouteNames.EditorRequestsRoute,
          rules
        )
        PermissionPageManager.addRule(
          requestsRouteNames.NotificationsRequestsRoute,
          rules
        )

        PermissionPageManager.addRule(
          managementRouteNames.PublicationsApproveRoute,
          rules
        )
        PermissionPageManager.addRule(
          managementRouteNames.AffiliationsConfigRoute,
          rules
        )
        PermissionPageManager.addRule(managementRouteNames.AuthorsRoute, rules)
        PermissionPageManager.addRule(
          managementRouteNames.PublicationsDuplicatesRoute,
          rules
        )
        PermissionPageManager.addRule(
          managementRouteNames.PublicationsRequestsRoute,
          rules
        )
        PermissionPageManager.addRule(
          journalsRouteNames.JournalsCheckRoute,
          rules
        )
      }
      if (this.user('isAuthor')) {
        PermissionPageManager.addRule(
          requestsRouteNames.AuthorRequestsRoute,
          rules
        )
        PermissionPageManager.addRule(
          publicationsRouteNames.MyEditRequests,
          rules
        )
      }

      if (isDev) {
        PermissionPageManager.addRule(devRouteNames.ChangeRoleRoute, rules)
        PermissionPageManager.addRule(devRouteNames.ChangeUserRoute, rules)
        PermissionPageManager.addRule(devRouteNames.ServerAPIRoute, rules)
      }
    }

    if (!this.user('isAuthenticated')) {
      PermissionPageManager.addRule(authRouteNames.AuthMainRoute, rules)
    }

    // Для всех пользователей
    PermissionPageManager.addRule(commonRouteNames.ErrorRoute, rules)
    PermissionPageManager.addRule(commonRouteNames.ChangelogRoute, rules)

    PermissionPageManager.addRule(commonRouteNames.MainPageRoute, rules)
    PermissionPageManager.addRule(commonRouteNames.HelpRoute, rules)
    PermissionPageManager.addRule(journalsRouteNames.JournalsListRoute, rules)
    PermissionPageManager.addRule(
      publicationsRouteNames.PublicationsListRoute,
      rules
    )
    PermissionPageManager.addRule(
      publicationsRouteNames.PublicationRoute,
      rules
    )

    return rules
  }

  private static user(getterName: string) {
    return store.getters[`user/${getterName}`]
  }

  // Права на просмотр страниц (Router)
  public static pages() {
    const pageList = PermissionPageManager._pages()
    return defineAbility(can => {
      for (const page of Object.keys(pageList)) {
        can(permissions.viewPage, page)
      }
    })
  }

  private static addRule(name: string, rules: any): void {
    rules[name] = true
  }
}
